import { useCallback } from 'react';
import { useGetIdentity } from 'react-admin';
import { supabase } from '../providers/supabase/supabase';

export type HailProductDefsCsvRow = {
    'Hail Product'?: string;
    hail_product?: string;
    Hail_Product?: string;
    Definition?: string;
    definition?: string;
    'Hail Product Alias'?: string;
    'Coverage Alias'?: string;
    hail_product_alias?: string;
    Hail_Product_Alias?: string;
};

function normalizeRow(raw: HailProductDefsCsvRow) {
    const hail_product = (
        raw['Hail Product'] ??
        raw.hail_product ??
        raw.Hail_Product ??
        ''
    )
        .toString()
        .trim();
    const definition = (raw.Definition ?? raw.definition ?? '')
        .toString()
        .trim();
    const hail_product_alias = (
        raw['Hail Product Alias'] ??
        raw['Coverage Alias'] ??
        raw.hail_product_alias ??
        raw.Hail_Product_Alias ??
        ''
    )
        .toString()
        .trim();

    return { hail_product, definition, hail_product_alias };
}

export function useHailProductDefsImport() {
    const user = useGetIdentity();

    const processBatch = useCallback(
        async (batch: HailProductDefsCsvRow[]) => {
            const rows = batch.map(normalizeRow).filter(r => r.hail_product);

            if (rows.length === 0) return;

            const { error } = await supabase
                .from('hail_product_definitions')
                .insert(rows);

            if (error) {
                console.error('Hail product defs import batch error:', error);
                throw error;
            }
        },
        [user?.identity?.id]
    );

    return { processBatch };
}
